"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelmFile = void 0;
const app_module_1 = require("./app.module");
const core_1 = require("@angular/core");
const loading_service_1 = require("./loading.service");
const notification_service_1 = require("./notification.service");
const token_service_1 = require("./token.service");
const moment = require("moment");
class HelmFile {
    constructor() {
        this.baseURL = "/helm/file";
        this.path = "";
        this.fileName = "";
        this.daily = true;
        this.raw = true;
        this.dataEvent = {};
        this.groupByClient = ["export_client_id", "client_id"];
        this.groupByAdUnitCode = ["adunitcode"];
        this.rawCols = [
            "export_renders",
            "export_adjusted_renders",
            "export_renders_discrepancy",
            "export_revenue",
            "export_adjusted_revenue",
            "export_revenue_discrepancy",
            "export_ecpm",
            "export_adjusted_ecpm",
            "export_ecpm_discrepancy",
            "export_original_adjusted_renders",
            "export_original_adjusted_revenue",
        ];
        this.percentageCols = [
            "export_renders",
            "export_adjusted_renders",
            "export_renders_discrepancy",
            "export_revenue",
            "export_adjusted_revenue",
            "export_revenue_discrepancy",
            "export_ecpm",
            "export_adjusted_ecpm",
            "export_ecpm_discrepancy",
            "export_original_renders_discrepancy",
            "export_original_revenue_discrepancy",
        ];
    }
    upload() {
        return __awaiter(this, void 0, void 0, function* () {
            let loading = app_module_1.AppModule.injector.get(loading_service_1.LoadingService);
            let talk = app_module_1.AppModule.injector.get(notification_service_1.NotificationService);
            try {
                this.data = yield this.getFileData();
                let status = yield this.uploadFile();
            }
            catch (err) { }
        });
    }
    download({ date, dsp }) {
        let payload = this.buildPayload(date, dsp);
        let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
        let loading = app_module_1.AppModule.injector.get(loading_service_1.LoadingService);
        let talk = app_module_1.AppModule.injector.get(notification_service_1.NotificationService);
        loading.start();
        return new Promise((resolve, reject) => {
            http
                .post(`${this.baseURL}/download`, JSON.stringify(payload))
                .toPromise()
                .then((response) => {
                const OK = 200;
                loading.stop();
                if (response.status === OK) {
                    let res = JSON.parse(response._body);
                    let link = document.createElement("a");
                    link.href = `/export/getfile/xlsx/${res.exportName}`;
                    link.download = res.filename;
                    link.click();
                    resolve(undefined);
                }
                else {
                    talk.broadcast("An error occured");
                    return;
                }
            })
                .catch((err) => {
                let res = err.json ? err.json() : err;
                let msg = res.message
                    ? res.message
                    : "An error occurred. Please be sure that there is data for the given date and interval.";
                talk.broadcast(msg);
                loading.stop();
                return;
            });
        });
    }
    buildPayload(dateObject, dsp) {
        let end = moment(dateObject, "MMMM Do YYYY")
            .endOf("day")
            .startOf("hour")
            .format("YYYY-MM-DD HH:mm:ss");
        let start = moment(dateObject, "MMMM Do YYYY")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        let interval = this.daily ? "daily" : "hourly";
        this.cols = this.raw ? this.rawCols : this.percentageCols;
        let group = this.getGroupBy();
        return {
            data_source: "rtbx-helm-write",
            tz: "+00:00",
            dateRange: "Custom Range",
            cumulativeView: false,
            adminrestrictdata: false,
            exportType: "xlsx",
            sortBy: "client_id",
            sortOrder: "desc",
            col: this.cols,
            interval,
            start,
            end,
            group,
            bidder: [dsp.val],
            helm: {
                type: this.raw ? "raw" : "discrepancy",
                billing: dsp.billingSource ? "emx" : "dsp",
            },
        };
    }
    getGroupBy() {
        let group = [];
        let additionalCols = [];
        if (this.reportTypes.publisher) {
            group.push("client_id");
            group.push("export_client_id");
            additionalCols = [...this.groupByClient, ...additionalCols];
        }
        if (this.reportTypes.tags) {
            group.push("adunitcode");
            additionalCols = [...this.groupByAdUnitCode, ...additionalCols];
        }
        this.cols = [...additionalCols, ...this.cols];
        return group;
    }
    getFileData() {
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
            if (this.dataEvent &&
                this.dataEvent.target &&
                this.dataEvent.target.files &&
                this.dataEvent.target.files.length) {
                this.fileName = this.dataEvent.target.files[0].name;
                const [file] = this.dataEvent.target.files;
                reader.readAsBinaryString(file);
                reader.onload = () => {
                    resolve(reader.result);
                };
            }
            else {
                reject();
            }
        });
    }
    uploadFile() {
        let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
        let talk = app_module_1.AppModule.injector.get(notification_service_1.NotificationService);
        let p = this.path.split("fakepath\\")[1];
        return new Promise((resolve, reject) => {
            http
                .post(`${this.baseURL}/upload`, {
                body: JSON.stringify({ workbook: this.data, filePath: p }),
            })
                .toPromise()
                .then((response) => {
                const OK = 200;
                if (response.status === OK) {
                    resolve("File Upload Success!");
                }
                else {
                    talk.broadcast(response);
                    resolve(undefined);
                }
            })
                .catch((err) => {
                reject(err);
            });
        });
    }
}
exports.HelmFile = HelmFile;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], HelmFile.prototype, "datetime", void 0);
//# sourceMappingURL=helmFile.js.map